export default "__VITE_ASSET__CZI_Cd_e__"